<template>
    <div class="detail-page">
        <button class="button-close" v-on:click="close"></button>
        <div class="content" v-if="currentSlide > 0">
            <div class="content-hero">
                <div class="title content-container">
                    <div class="background">
                        <div class="hero-vid">
                            <video width="100%" heght="100%" :src="require('@/assets/hero_' + currentSlide + '.mp4')" autoplay muted playsinline loop>
                            </video>
                            <div class="mobile-bg" :style=" { 'background-image': 'url(' + require('@/assets/mobile_bg_' + currentSlide + '.jpg') + ')' }"></div>
                        </div>
                    </div>
                    <h2 class="carousel-title"></h2>
                    <div class="title-description"></div>
                    <div class="scrolldown">
                        <div class="scrolldown-content">
                            <span class="arrow mobile"></span>Scroll<span class="arrow"></span>
                        </div>
                    </div>
                    <div class="cover"></div>
                </div>
            </div>
            <div class="content-desc">
                <section class="upper content-container">
                    <h4 class="quote animate"></h4>
                    <h5 class="author animate" v-html="content[currentSlide].author"></h5>
                    <div class="squiggly squiggly-0 type-a"></div>
                    <div class="squiggly squiggly-1 type-b"></div>
                </section>
                <section class="lower content-container">
                    <h6 class="subtitle animate">{{ content[currentSlide].title }} at Baunfire</h6>
                    <div class="description animate">{{ content[currentSlide].description }}</div>
                    <div class="squiggly squiggly-2 type-b"></div>
                    <div class="squiggly squiggly-3 type-b"></div>
                </section>
                <section class="foot">
                    <div class="foot-logo">
                        <a href="https://www.baunfire.com" target="_blank">
                            <picture>
                                <source srcset="@/assets/baunfire_white@2x.png 2x, @/assets/baunfire_white.png 1x">
                                <img src="@/assets/baunfire_white.png" alt="Baunfire logo">
                            </picture>
                        </a>
                    </div>
                    <div class="link">
                        <a href="https://www.baunfire.com" target="_blank">baunfire.com</a>
                    </div>
                </section>
            </div>
        </div>
    </div>    
</template>

<script>
import hero from "lottie-web";
import * as heroData1 from "@/assets/hero_1.json";
import * as heroData2 from "@/assets/hero_2.json";
import * as heroData3 from "@/assets/hero_3.json";
import * as heroData4 from "@/assets/hero_4.json";
import * as heroData5 from "@/assets/hero_5.json";
import * as heroData6 from "@/assets/hero_6.json";

export default {
    name: "detailPage",
    props: ["currentSlide"],
    data: function() {
        return {
            heroGraphic: null,
            content: [
                {
                    title: null,
                    quote: null,
                    author: null,
                    description: null
                },
                {
                    title: "Necessity",
                    subtitle:
                        "Businesses and brands throughout Silicon Valley are<br>seeing the value of great design.",
                    quote:
                        "“Design is an expectation of so many companies. It’s a skillset that’s no longer a luxury, but a necessity.”",
                    author: "Ian Chee, Facebook<br>Director of Brand",
                    description:
                        "As a Silicon Valley agency, we often say that we were “born in digital.” Over the years, we’ve helped businesses grow and seen companies mature, particularly within design. What was once an afterthought is clearly at the forefront of tech today — from product, to marketing, to operations."
                },
                {
                    title: "Leadership",
                    subtitle:
                        "Design is changing the way companies identify and<br>solve businesses challenges.",
                    quote:
                        "“Beyond interfaces, design leadership helps map out how we design business units, structures, and teams.”",
                    author: "Alex Schleifer, Airbnb<br>Head of Design",
                    description:
                        "We believe that great design should also exist off of the screen. When organizations take a thoughtful approach to designing internal operations, they can expect a more positive impact on the culture and output. Companies, even at the enterprise level, are seeing the value of design leadership."
                },
                {
                    title: "Creativity",
                    subtitle:
                        "Companies are investing more time and resources<br>into design in order to stand out.",
                    quote:
                        "“More companies are incorporating design into their process, and as the future unfolds, creativity is going to matter.”",
                    author: "Ian Spalter, Instagram<br>Head of Design",
                    description:
                        "With more designers having a seat at the table, there’s a higher expectation to deliver great work at companies that have made the investment. Across virtually every industry, the quality of design has improved. Brands look to strong, ownable messaging to stand out and succeed."
                },
                {
                    title: "Intent",
                    subtitle:
                        "Great designers have the ability to solve complex<br>problems within organizations.",
                    quote:
                        "“The mark of a really great designer is that every decision they’ve made has a purpose — has intentionality.”",
                    author: "Julie Zhuo, Facebook<br>VP of Product Design",
                    description:
                        "We take a design-driven, strategy-led approach to every project we ship. It’s important to keep in mind that a corporate website is a business tool; aside from communicating visual identity and core messaging, it should ultimately guide customers to convert and perform a desired action."
                },
                {
                    title: "Diversity",
                    subtitle:
                        "Brands and businesses are finding that fresh ideas<br>come from diverse perspectives.",
                    quote:
                        "“Diversity, particularly within design, opens up more opportunities for innovation and better outcomes.”",
                    author:
                        "August de los Reyes, Google<br>Director of User Experience",
                    description:
                        "As a creative agency, diversity has played an essential role in our design approach. Our team consists  of individuals from various backgrounds, from ethnicity, gender, and age, to skillsets, interests, and perspectives. For us, this creates an environment where uniquely great ideas to thrive."
                },
                {
                    title: "Culture",
                    subtitle:
                        "Design is continuously evolving the culture in Silicon<br>Valley and across the globe.",
                    quote:
                        "“Designers are creating culture; we’re making artifacts that people are interfacing with every day.”",
                    author:
                        "Kristy Tillman, Slack<br>Director of Global Workplace Design",
                    description:
                        "As the impact of design becomes more and more significant in Silicon Valley, the role of designers to identify and solve complex business problems has become invaluable. Great design has become a cornerstone to culture, influencing our day-to-day interactions with people and technology."
                }
            ],
            windowHeight: 0,
            scrollY: 0,
            upperY: 0,
            lowerY: 0,
            squigglyY: {
                asset0: 0,
                asset1: 0,
                asset2: 0,
                asset3: 0
            },
            squigglyRange: {
                asset0: 2000,
                asset1: 700,
                asset2: 1600,
                asset3: 1000
            },
            coverOpacityRate: 0,
            animate: false,
            prevScrollY: 0
        };
    },
    methods: {
        show: function() {
            this.windowHeight = this.$el.querySelector(
                ".content-hero"
            ).offsetHeight;
            this.$el.classList.add("show");
            this.$el.querySelector(".carousel-title").innerText = this.content[
                this.currentSlide
            ].title;
            this.$el.querySelector(
                ".title-description"
            ).innerHTML = this.content[this.currentSlide].subtitle;

            this.$el.querySelector(".content").scrollTop = 0;
            this.$el.querySelector(".cover").style.transform = "scale(1, 0)";

            let quote = this.$el.querySelector(".quote");
            quote.innerText = this.content[this.currentSlide].quote;

            if (window.innerWidth > 1024) {
                this.$el
                    .querySelector(".content")
                    .addEventListener("scroll", this.trackScroll);
                requestAnimationFrame(this.moveAssets);
                this.animate = true;

                let words = this.content[this.currentSlide].quote.split(" ");
                quote.innerHTML = "";

                words.forEach(word => {
                    let wordWrapper = document.createElement("div");
                    wordWrapper.classList.add("word");

                    let letters = word.split("");

                    letters.forEach(letter => {
                        let div = document.createElement("div");
                        div.classList.add("letter");
                        div.innerHTML = letter == " " ? "&nbsp;" : letter;

                        wordWrapper.appendChild(div);
                    });

                    let space = document.createElement("div");
                    space.classList.add("letter");
                    space.innerHTML = "&nbsp;";
                    wordWrapper.appendChild(space);
                    quote.appendChild(wordWrapper);
                });
            } else {
                //mobile
                const assets = this.$el.querySelectorAll(".animate");

                assets.forEach(asset => {
                    asset.classList.add("show");
                });
            }
        },
        close: function() {
            this.$emit("close");
            this.$el.classList.remove("show");

            this.$el
                .querySelector(".content")
                .removeEventListener("scroll", this.trackScroll);
            this.animate = false;
            cancelAnimationFrame(this.moveAssets);
            this.$el.querySelector(".cover").style.transform = "scale(1, 0)";

            const assets = this.$el.querySelectorAll(".animate");

            assets.forEach(asset => {
                asset.classList.remove("show");
            });
        },
        trackScroll: function(event) {
            this.scrollY = event.target.scrollTop;
            const assets = this.$el.querySelectorAll(".animate");

            assets.forEach(asset => {
                if (
                    !asset.classList.contains("show") &&
                    asset.getBoundingClientRect().top <=
                        this.windowHeight * 0.75
                ) {
                    asset.classList.add("show");
                }
            });
        },
        moveAssets: function() {
            let upperDistY = (this.scrollY * 200) / 1300 - this.upperY;
            let lowerDistY = (this.scrollY * 100) / 1300 - this.lowerY;

            this.upperY += upperDistY / 5;
            this.lowerY += lowerDistY / 5;

            this.$el.querySelector(".upper").style.transform =
                "translate3d(0, -" + this.upperY + "px, 0)";
            this.$el.querySelector(".lower").style.transform =
                "translate3d(0, -" + this.lowerY + "px, 0)";

            let squiggly = this.$el.querySelectorAll(".squiggly");

            squiggly.forEach((asset, index) => {
                let distY =
                    (this.scrollY * 200) / this.squigglyRange["asset" + index] -
                    this.squigglyY["asset" + index];

                this.squigglyY["asset" + index] += distY / 5;

                asset.style.transform =
                    "translate3d(0, -" +
                    this.squigglyY["asset" + index] +
                    "px, 0)";
            });

            let coverRate =
                this.scrollY / this.windowHeight - this.coverOpacityRate;

            this.coverOpacityRate += coverRate / 3;
            this.coverOpacityRate =
                this.coverOpacityRate > 1 ? 1 : this.coverOpacityRate;

            this.$el.querySelector(".cover").style.transform =
                "scale(1, " + this.coverOpacityRate + ")";

            if (this.animate) {
                requestAnimationFrame(this.moveAssets);
            }
        }
    }
};
</script>

<style lang="scss">
.detail-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #faf8f0;
    transition: max-height 0.65s $primary-ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 9;
    overflow: auto;
    pointer-events: none;
    max-height: 0;
    -webkit-overflow-scrolling: touch;

    &.show {
        pointer-events: all;
        max-height: 100vh;
    }

    .content {
        overflow: auto;

        &-hero {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            position: relative;

            .detail-title {
                transform: translate3d(100px, 2px, 0);

                @media ($tablet-screen) {
                    transform: translate3d(0, 2px, 0);
                }

                @media ($mobile-screen) {
                    transform: translate3d(0, 205px, 0);
                }
            }

            .background {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                line-height: 0;

                .hero-vid {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 100vh;
                    overflow: hidden;

                    video {
                        @media ($mobile-screen) {
                            display: none;
                        }
                    }

                    .mobile-bg {
                        display: none;

                        @media ($mobile-screen) {
                            display: block;
                            background-repeat: no-repeat;
                            background-size: cover;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }

            .cover {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: $color-black;
                transform: scale(1, 0);
                transform-origin: bottom;
            }

            .scrolldown {
                @include playfair-black;
                font-size: 20px;
                position: absolute;
                left: 50px;
                bottom: 150px;
                -webkit-font-smoothing: subpixel-antialiased;

                @media ($mobile-screen) {
                    font-size: 15px;
                    right: 32px;
                    bottom: 116px;
                    left: auto;
                    right: 29px;
                    bottom: 116px;
                }

                &-content {
                    transform: rotate(90deg);
                    transform-origin: bottom left;

                    @media ($mobile-screen) {
                        transform: rotate(-90deg);
                        transform-origin: bottom right;
                    }
                }

                .arrow {
                    display: inline-block;
                    position: relative;
                    padding-left: 20px;

                    @media ($mobile-screen) {
                        display: none;
                    }

                    &:before {
                        content: "";
                        display: block;
                        width: 25px;
                        height: 1px;
                        background-color: $color-black;
                    }

                    &:after {
                        content: "";
                        display: block;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: 10px;
                        height: 1px;
                        background-color: $color-black;
                        transform: rotate(45deg);
                        transform-origin: right;
                    }

                    &.mobile {
                        display: none;
                        padding-left: 0px;
                        padding-right: 20px;

                        @media ($mobile-screen) {
                            display: inline-block;
                        }

                        &:after {
                            transform: rotate(-45deg);
                            transform-origin: left;
                            left: 0;
                            right: auto;
                        }
                    }
                }
            }

            .carousel-title {
                font-size: 120px;
                position: relative;
                height: 200px;
                margin-left: 100px;

                @media ($tablet-screen) {
                    margin-left: 0;
                }

                @media ($laptop-screen) {
                    font-size: 100px;
                }

                @media ($mobile-screen) {
                    font-size: 50px;
                    margin-left: 0;
                    transform: translate3d(0, 200px, 0);
                }
            }

            .title-description {
                @include mukta-light;
                font-size: 25px;
                position: absolute;
                margin-left: 100px;

                @media ($laptop-screen) {
                    transform: translate3d(0, -30px, 0);
                }

                @media ($smallest-laptop-screen) {
                    font-size: 20px;
                    transform: translate3d(0, -50px, 0);
                }

                @media ($mobile-screen) {
                    margin-left: 0;
                    font-size: 13px;
                    transform: translate3d(0, 80px, 0);
                }
            }
        }

        &-desc {
            color: white;
            background: url("../assets/detail_bg_a.png") right
                    calc(((100vw - 1400px) / 2) - 380px) top 115px no-repeat,
                url("../assets/detail_bg_b.png") left calc((100vw - 1400px) / 2)
                    top 805px no-repeat;
            background-color: $color-black;
            padding: 200px 0 0;
            box-sizing: border-box;

            @media ($mobile-screen) {
                padding: 100px 0 0;
            }

            .quote {
                @include playfair-regular;
                font-size: 80px;
                line-height: 100px;
                max-width: 80%;

                @media ($laptop-screen) {
                    font-size: 70px;
                }

                @media ($small-laptop-screen) {
                    font-size: 60px;
                    line-height: 70px;
                    max-width: 70%;
                }

                @media ($smallest-laptop-screen) {
                    font-size: 50px;
                    line-height: 60px;
                    max-width: 70%;
                }

                @media ($mobile-screen) {
                    font-size: 28px;
                    line-height: 35px;
                }

                .word {
                    display: inline-block;
                }

                .letter {
                    display: inline-block;
                    transform: translate3d(0, 0, 0);
                    opacity: 0;

                    @for $i from 1 through 50 {
                        &:nth-of-type(#{$i}) {
                            transition: all
                                0.65s
                                $primary-ease
                                random(10) *
                                0.05s;
                        }
                    }
                }

                &.show {
                    .letter {
                        transform: translate3d(0, 0, 0);
                        opacity: 1;
                    }
                }
            }

            .author {
                @include mukta-extralight;
                font-size: 30px;
                line-height: 40px;
                color: #cccccc;
                margin-top: 60px;
                opacity: 0;
                transition: opacity 0.85s $primary-ease;

                @media ($laptop-screen) {
                    font-size: 25px;
                }

                @media ($small-laptop-screen) {
                    font-size: 23px;
                    line-height: 35px;
                }

                @media ($mobile-screen) {
                    font-size: 15px;
                    line-height: 25px;
                    margin-top: 30px;
                }

                &.show {
                    opacity: 1;
                }
            }

            .subtitle {
                @include mukta-medium;
                font-size: 25px;
                margin-top: 300px;
                margin-left: 25%;
                color: $color-red;
                opacity: 0;
                transition: all 0.85s $primary-ease;
                transform: translate3d(0, 50px, 0);
                text-transform: uppercase;

                @media ($laptop-screen) {
                    font-size: 20px;
                }

                @media ($mobile-screen) {
                    font-size: 15px;
                    margin-left: 0;
                    margin-top: 100px;
                }

                &.show {
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                }
            }

            .description {
                font-size: 30px;
                line-height: 60px;
                margin-top: 50px;
                margin-left: 25%;
                max-width: 40%;
                opacity: 0;
                transition: all 0.85s $primary-ease;
                transform: translate3d(0, 50px, 0);

                @media ($laptop-screen) {
                    font-size: 25px;
                    line-height: 50px;
                }

                @media ($mobile-screen) {
                    margin-left: 0;
                    font-size: 20px;
                    line-height: 30px;
                    max-width: 80%;
                }

                &.show {
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                }
            }

            .upper,
            .lower {
                position: relative;
            }

            .squiggly {
                position: absolute;

                @media ($mobile-screen) {
                    display: none;
                }

                &-0 {
                    top: 0;
                    left: -50px;
                }

                &-1 {
                    bottom: 0;
                    right: 200px;

                    @media ($mobile-screen) {
                        right: 0;
                        bottom: -250px;
                    }
                }

                &-2 {
                    top: -50px;
                    left: -30px;
                }

                &-3 {
                    bottom: -300px;
                    right: 200px;
                }

                &.type-a {
                    background: url("../assets/squiggly_0.png") no-repeat;
                    width: 107px;
                    height: 168px;
                }

                &.type-b {
                    background: url("../assets/squiggly_1.png") no-repeat;
                    width: 94px;
                    height: 158px;
                }
            }

            .foot {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                padding: 300px 52px 50px;
                box-sizing: border-box;

                @media ($mobile-screen) {
                    padding: 100px 26px 150px;
                }

                .link {
                    @include playfair-black;
                    font-size: 20px;
                    color: $color-red;

                    @media ($mobile-screen) {
                        font-size: 15px;
                        transform: translate3d(0, -5px, 0);
                    }

                    a {
                        @media ($desktop-screen) {
                            &:after {
                                content: "";
                                display: block;
                                width: 100%;
                                height: 1px;
                                background-color: $color-red;
                                transform: scale(0, 1);
                                transform-origin: right;
                                transition: transform 0.55s $primary-ease;
                            }

                            &:hover {
                                &:after {
                                    transform: scale(1, 1);
                                    transform-origin: left;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.button-close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 65px auto 0;
    cursor: pointer;
    z-index: 14;

    @media ($mobile-screen) {
        margin: 30px auto 0;
    }

    &:before,
    &:after {
        content: "";
        position: absolute;
        height: 3px;
        width: 100%;
        top: 50%;
        left: 0;
        margin-top: -1px;
        background: $color-red;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after {
        transform: rotate(-45deg);
    }
}
</style>